import { createI18nText } from '@hilma/netina2all';

const associationRulesText = createI18nText({
	he: {
		assoName: 'שם העמותה',
		contactName: 'שם איש הקשר',
		phone: 'מספר הפלאפון'
	},
	en: {
		assoName: "association's name",
		contactName: "contact's name",
		phone: 'phone number'

	}
});

export default associationRulesText;